// extracted by mini-css-extract-plugin
module.exports = {"questions":"Questions_questions__ISTaf"};